module.exports = __webpack_public_path__ + "877008b045c438a36261f02e6cf7b3ee.woff";